module.exports = __webpack_public_path__ + "static/media/logo.8b8e3c3e.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/brand/brands/actiway/media/logo.png
// module id = 859
// module chunks = 0